@if (isDateFormatColumn()) {
  @if (usesPrimeCellEditing()) {
    <td
      pEditableColumn
      [pEditableColumn]="row()"
      [pEditableColumnField]="col().binding"
      [pEditableColumnRowIndex]="ri()"
      [pFocusCellSelector]="primeCellEditFocusSelector()"
      [style.width]="col().width === '*' ? 'auto' : col().width ? col().width + 'px' : 'auto'">
      <p-cellEditor>
        <ng-template pTemplate="output">
          <span class="kl-grid-form-cell-display">{{ formatDisplayValue()(row(), col(), ri()) }}</span>
        </ng-template>
        <ng-template pTemplate="input">
          <p-datepicker
            class="w-100"
            [ngModel]="resolveDateCellValue()(row(), col())"
            (ngModelChange)="onDateChange($event)"
            [showTime]="col().format === 'date-time'"
            [dateFormat]="datePickerFormat()"
            appendTo="body"
            iconDisplay="input"
            inputStyleClass="p-inputtext-sm w-100"
            panelStyleClass="kl-datepicker-panel" />
        </ng-template>
      </p-cellEditor>
    </td>
  } @else {
    <td [style.width]="col().width === '*' ? 'auto' : col().width ? col().width + 'px' : 'auto'">
      @if (isCellEditorMode()) {
        <p-datepicker
          class="w-100"
          [ngModel]="resolveDateCellValue()(row(), col())"
          (ngModelChange)="onDateChange($event)"
          [showTime]="col().format === 'date-time'"
          [dateFormat]="datePickerFormat()"
          appendTo="body"
          iconDisplay="input"
          inputStyleClass="p-inputtext-sm w-100"
          panelStyleClass="kl-datepicker-panel"
          [disabled]="col().isReadOnly === true" />
      } @else {
        <span class="kl-grid-form-cell-display">{{ formatDisplayValue()(row(), col(), ri()) }}</span>
      }
    </td>
  }
} @else {
  @switch (col().type === 'decimal' ? 'number' : col().type) {
    @case ('index') {
      <td [style.width]="col().width === '*' ? 'auto' : col().width ? col().width + 'px' : 'auto'">
        <span class="kl-grid-form-index">{{ ri() + 1 }}</span>
      </td>
    }
    @case ('button') {
      <td
        class="text-center kl-grid-form-cell--button"
        [style.width]="col().width === '*' ? 'auto' : col().width ? col().width + 'px' : 'auto'">
        <p-button
          type="button"
          [icon]="col().button?.icon ?? 'ph ph-barcode'"
          severity="secondary"
          size="small"
          [text]="true"
          [rounded]="true"
          [disabled]="isReadOnly() || isActionDisabled()"
          [loading]="
            cellButtonPending()?.rowIndex === resolveSourceRowIndex()(ri()) &&
            cellButtonPending()?.binding === col().binding
          "
          [attr.aria-label]="col().button?.label ?? col().header | translate"
          (onClick)="onCellButtonClick($event)" />
      </td>
    }
    @case ('action-button') {
      <td
        class="text-center kl-grid-form-cell--button"
        [style.width]="col().width === '*' ? 'auto' : col().width ? col().width + 'px' : 'auto'">
        <p-button
          type="button"
          [icon]="col().button?.icon ?? 'ph ph-list'"
          [label]="col().button?.label ?? col().header | translate"
          severity="secondary"
          size="small"
          [outlined]="true"
          [disabled]="isReadOnly() || isActionDisabled()"
          [loading]="
            cellButtonPending()?.rowIndex === resolveSourceRowIndex()(ri()) &&
            cellButtonPending()?.binding === col().binding
          "
          (onClick)="onCellButtonClick($event)" />
      </td>
    }
    @case ('checkbox') {
      <td [style.width]="col().width === '*' ? 'auto' : col().width ? col().width + 'px' : 'auto'">
        <span class="kl-grid-form-cell-display kl-grid-form-cell-display--checkbox">
          <p-checkbox
            [binary]="true"
            [ngModel]="!!getNested()(row(), col().binding)"
            (ngModelChange)="onCheckboxChange($event)"
            [disabled]="!isCellEditorMode()"
            [inputId]="'kl-gf-cb-' + ri() + '-' + col().binding"
            (click)="$event.stopPropagation()" />
        </span>
      </td>
    }
    @case ('select') {
      @if (usesPrimeCellEditing()) {
        <td
          pEditableColumn
          [pEditableColumn]="row()"
          [pEditableColumnField]="col().binding"
          [pEditableColumnRowIndex]="ri()"
          [pFocusCellSelector]="primeCellEditFocusSelector()"
          [style.width]="col().width === '*' ? 'auto' : col().width ? col().width + 'px' : 'auto'">
          <p-cellEditor>
            <ng-template pTemplate="output">
              <span class="kl-grid-form-cell-display">{{ formatDisplayValue()(row(), col(), ri()) }}</span>
            </ng-template>
            <ng-template pTemplate="input">
              <p-select
                class="w-100"
                [options]="resolveOptions() ?? []"
                [optionLabel]="col().optionLabel ?? 'code'"
                [optionValue]="col().optionValue ?? undefined"
                [ngModel]="getNested()(row(), col().binding)"
                (ngModelChange)="onSelectChange($event)"
                [disabled]="false"
                appendTo="body"
                [filter]="true"
                scrollHeight="150px">
                @if (col().translateOptionLabels) {
                  <ng-template let-item pTemplate="item">{{
                    item[col().optionLabel ?? 'label'] | translate
                  }}</ng-template>
                  <ng-template let-item pTemplate="selectedItem">
                    @if (item) {
                      {{ item[col().optionLabel ?? 'label'] | translate }}
                    }
                  </ng-template>
                }
              </p-select>
            </ng-template>
          </p-cellEditor>
        </td>
      } @else {
        <td [style.width]="col().width === '*' ? 'auto' : col().width ? col().width + 'px' : 'auto'">
          @if (isCellEditorMode()) {
            <p-select
              class="w-100"
              [options]="resolveOptions() ?? []"
              [optionLabel]="col().optionLabel ?? 'code'"
              [optionValue]="col().optionValue ?? undefined"
              [ngModel]="getNested()(row(), col().binding)"
              (ngModelChange)="onSelectChange($event)"
              [disabled]="false"
              appendTo="body"
              [filter]="true"
              scrollHeight="150px">
              @if (col().translateOptionLabels) {
                <ng-template let-item pTemplate="item">{{
                  item[col().optionLabel ?? 'label'] | translate
                }}</ng-template>
                <ng-template let-item pTemplate="selectedItem">
                  @if (item) {
                    {{ item[col().optionLabel ?? 'label'] | translate }}
                  }
                </ng-template>
              }
            </p-select>
          } @else {
            <span class="kl-grid-form-cell-display">{{ formatDisplayValue()(row(), col(), ri()) }}</span>
          }
        </td>
      }
    }
    @case ('picker') {
      @if (usesPrimeCellEditing()) {
        <td
          pEditableColumn
          [pEditableColumn]="row()"
          [pEditableColumnField]="col().binding"
          [pEditableColumnRowIndex]="ri()"
          [pFocusCellSelector]="pickerFocusCellSelector"
          [style.width]="col().width === '*' ? 'auto' : col().width ? col().width + 'px' : 'auto'">
          <p-cellEditor>
            <ng-template pTemplate="output">
              <span class="kl-grid-form-cell-display kl-grid-form-cell-display--picker-label">
                {{ pickerDisplayLabel()(row(), col()) }}
              </span>
            </ng-template>
            <ng-template pTemplate="input">
              <div class="kl-grid-form-picker-cell">
                @if (col().typablePicker) {
                  <input
                    pInputText
                    type="text"
                    class="p-inputtext-sm kl-grid-form-picker-cell__input"
                    [ngModel]="pickerInputValue()"
                    (ngModelChange)="onPickerTextTyped($event)"
                    (blur)="commitPickerText()"
                    (keydown.enter)="commitPickerText(); $event.preventDefault()"
                    (keydown.arrowleft)="$event.stopPropagation()"
                    (keydown.arrowright)="$event.stopPropagation()"
                    (pointerdown)="onCellInputPointerDown($event)"
                    (click)="$event.stopPropagation()" />
                } @else {
                  <span class="kl-grid-form-cell-display kl-grid-form-cell-display--picker-label">
                    {{ pickerDisplayLabel()(row(), col()) }}
                  </span>
                }
                @if (pickerHasDisplayValue()(row(), col())) {
                  <button
                    type="button"
                    class="kl-grid-form-picker-icon kl-grid-form-picker-icon--clear"
                    [attr.aria-label]="'clear' | translate"
                    (click)="onClearPickerClick(); $event.stopPropagation()">
                    <i class="ph ph-x" aria-hidden="true"></i>
                  </button>
                }
                <button
                  type="button"
                  class="kl-grid-form-picker-icon kl-grid-form-picker-icon--lookup"
                  [attr.aria-label]="'search' | translate"
                  (click)="onPickerButtonClick(); $event.stopPropagation()">
                  <i class="ph-bold ph-dots-three" aria-hidden="true"></i>
                </button>
              </div>
            </ng-template>
          </p-cellEditor>
        </td>
      } @else {
        <td [style.width]="col().width === '*' ? 'auto' : col().width ? col().width + 'px' : 'auto'">
          <span class="kl-grid-form-cell-display kl-grid-form-cell-display--picker-label">
            {{ pickerDisplayLabel()(row(), col()) }}
          </span>
        </td>
      }
    }
    @case ('number') {
      @if (usesPrimeCellEditing()) {
        <td
          pEditableColumn
          tabindex="-1"
          data-enter-nav
          [pEditableColumn]="row()"
          [pEditableColumnField]="col().binding"
          [pEditableColumnRowIndex]="ri()"
          [pFocusCellSelector]="primeCellEditFocusSelector()"
          [style.width]="col().width === '*' ? 'auto' : col().width ? col().width + 'px' : 'auto'">
          <p-cellEditor>
            <ng-template pTemplate="output">
              <span class="kl-grid-form-cell-display">{{ formatDisplayValue()(row(), col(), ri()) }}</span>
            </ng-template>
            <ng-template pTemplate="input">
              <p-inputNumber
                [ngModel]="getNested()(row(), col().binding)"
                (ngModelChange)="onNumberChange($event)"
                (onFocus)="selectAllOnFocus($event)"
                (onBlur)="commitCellEdit()"
                (onKeyDown)="$event.key === 'Enter' && commitCellEdit()"
                (keydown.arrowleft)="$event.stopPropagation()"
                (keydown.arrowright)="$event.stopPropagation()"
                (pointerdown)="onCellInputPointerDown($event)"
                [disabled]="false"
                [min]="col().min"
                [max]="col().max"
                [maxlength]="resolveMaxLength(10)"
                [minFractionDigits]="col().minFractionDigits ?? 0"
                [maxFractionDigits]="col().maxFractionDigits ?? 0"
                [useGrouping]="false"
                [locale]="translate.currentLang || 'tr'"
                mode="decimal"
                inputStyleClass="p-inputtext-sm w-100" />
            </ng-template>
          </p-cellEditor>
        </td>
      } @else {
        <td [style.width]="col().width === '*' ? 'auto' : col().width ? col().width + 'px' : 'auto'">
          @if (isCellEditorMode()) {
            <p-inputNumber
              [ngModel]="getNested()(row(), col().binding)"
              (ngModelChange)="onNumberChange($event)"
              (onFocus)="selectAllOnFocus($event)"
              (onBlur)="commitCellEdit()"
              (onKeyDown)="$event.key === 'Enter' && commitCellEdit()"
              (keydown.arrowleft)="$event.stopPropagation()"
              (keydown.arrowright)="$event.stopPropagation()"
              (pointerdown)="onCellInputPointerDown($event)"
              [disabled]="false"
              [min]="col().min"
              [max]="col().max"
              [maxlength]="resolveMaxLength(10)"
              [minFractionDigits]="col().minFractionDigits ?? 0"
              [maxFractionDigits]="col().maxFractionDigits ?? 0"
              [useGrouping]="false"
              [locale]="translate.currentLang || 'tr'"
              mode="decimal"
              inputStyleClass="p-inputtext-sm w-100" />
          } @else {
            <span class="kl-grid-form-cell-display">{{ formatDisplayValue()(row(), col(), ri()) }}</span>
          }
        </td>
      }
    }
    @case ('password') {
      @if (usesPrimeCellEditing()) {
        <td
          pEditableColumn
          [pEditableColumn]="row()"
          [pEditableColumnField]="col().binding"
          [pEditableColumnRowIndex]="ri()"
          [pFocusCellSelector]="primeCellEditFocusSelector()"
          [style.width]="col().width === '*' ? 'auto' : col().width ? col().width + 'px' : 'auto'">
          <p-cellEditor>
            <ng-template pTemplate="output">
              <span class="kl-grid-form-cell-display">{{ getNested()(row(), col().binding) ? '••••••' : '' }}</span>
            </ng-template>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="password"
                class="p-inputtext-sm w-100"
                [ngModel]="getNested()(row(), col().binding)"
                (ngModelChange)="onTextChange($event)"
                (blur)="commitCellEdit()"
                (keydown.enter)="commitCellEdit(); $event.preventDefault()"
                (keydown.arrowleft)="$event.stopPropagation()"
                (keydown.arrowright)="$event.stopPropagation()"
                (pointerdown)="onCellInputPointerDown($event)"
                [disabled]="false"
                [maxlength]="resolveMaxLength(100)" />
            </ng-template>
          </p-cellEditor>
        </td>
      } @else {
        <td [style.width]="col().width === '*' ? 'auto' : col().width ? col().width + 'px' : 'auto'">
          @if (isCellEditorMode()) {
            <input
              pInputText
              type="password"
              class="p-inputtext-sm w-100"
              [ngModel]="getNested()(row(), col().binding)"
              (ngModelChange)="onTextChange($event)"
              (blur)="commitCellEdit()"
              (keydown.enter)="commitCellEdit(); $event.preventDefault()"
              (pointerdown)="onCellInputPointerDown($event)"
              [disabled]="false"
              [maxlength]="resolveMaxLength(100)" />
          } @else {
            <span class="kl-grid-form-cell-display">{{ getNested()(row(), col().binding) ? '••••••' : '' }}</span>
          }
        </td>
      }
    }
    @default {
      @if (usesPrimeCellEditing()) {
        <td
          pEditableColumn
          tabindex="-1"
          data-enter-nav
          [pEditableColumn]="row()"
          [pEditableColumnField]="col().binding"
          [pEditableColumnRowIndex]="ri()"
          [pFocusCellSelector]="primeCellEditFocusSelector()"
          [style.width]="col().width === '*' ? 'auto' : col().width ? col().width + 'px' : 'auto'">
          <p-cellEditor>
            <ng-template pTemplate="output">
              <span class="kl-grid-form-cell-display">{{ formatDisplayValue()(row(), col(), ri()) }}</span>
            </ng-template>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="text"
                class="p-inputtext-sm w-100"
                [ngModel]="getNested()(row(), col().binding)"
                (ngModelChange)="onTextChange($event)"
                (blur)="commitCellEdit()"
                (keydown.enter)="commitCellEdit(); $event.preventDefault()"
                (keydown.arrowleft)="$event.stopPropagation()"
                (keydown.arrowright)="$event.stopPropagation()"
                (pointerdown)="onCellInputPointerDown($event)"
                [disabled]="false"
                [maxlength]="resolveMaxLength(100)" />
            </ng-template>
          </p-cellEditor>
        </td>
      } @else {
        <td [style.width]="col().width === '*' ? 'auto' : col().width ? col().width + 'px' : 'auto'">
          @if (isCellEditorMode()) {
            <input
              pInputText
              type="text"
              class="p-inputtext-sm w-100"
              [ngModel]="getNested()(row(), col().binding)"
              (ngModelChange)="onTextChange($event)"
              (blur)="commitCellEdit()"
              (keydown.enter)="commitCellEdit(); $event.preventDefault()"
              (pointerdown)="onCellInputPointerDown($event)"
              [disabled]="false"
              [maxlength]="resolveMaxLength(100)" />
          } @else {
            <span class="kl-grid-form-cell-display">{{ formatDisplayValue()(row(), col(), ri()) }}</span>
          }
        </td>
      }
    }
  }
}
